/*
 *  Module: social
 */

require('modaal/dist/js/modaal');

import utilities from './utilities.js';

var defaults = {
	channelAttrName: "share-channel"
};

/**
 * Constructor
 * @param {Object} options Optional properties to override defaults
 */
function SocialShare(options) {
	this.options = $.extend({}, defaults, options);
	this.init();
	this.initEmailShare();

	$.ajax({
		url: urls.ajax,
		dataType: 'json',
		type: 'GET',
		data: {
			action: 'mg_get_modal'
		}
	});
}

/**
 * Setup
 */
SocialShare.prototype.init = function () {
	var self = this;
	// Grab all the elements with valid channel data attributes
	$('[data-' + self.options.channelAttrName + ']').each(function() {
		// on click trigger the appropriate share function
		$(this).on('click', function () {
			var data = $(this).data();
			var channel = data[ utilities.dashToCamel(self.options.channelAttrName) ];

			if( channel === 'email' ) {				
				return false;
			}

			var url = self[channel + 'Share'](data);
			// if url is set open popup
			var popup = (url) ? window.open(url, 'share', 'resizable=yes,scrollbars=yes,width=600,height=500') : false;
			return false;
		});
	});
}

/**
 * Open modal with email share form
 */
SocialShare.prototype.initEmailShare = function () {
	var self = this;

	// open lightbox with form
	$('[data-' + self.options.channelAttrName + '=email]').modaal({
		type: 'ajax',
		background: '#2a5595',
		overlay_opacity: '0.9',
		ajax_success: function() {
			var form = $('.form--email-share');
			var button = form.find('[type="submit"]');

			form.on('submit', function(e) {
				e.preventDefault();

				if( !button.attr('disabled') ) {
					$.ajax({
						url: urls.ajax,
						type: 'POST',
						data: {
							action: 'mg_submit_email_share_form',
							data: form.serialize(),
							nonce: form.data('nonce')
						},
						beforeSend: function() {
							button.attr('disabled', true );
						},
						success: function(data) {
							form.after('<div class="form__notice form__notice--success">Thank you for sharing!</div>');
							form.remove();
						},
						complete: function() {
							button.attr('disabled', false );
						}
					});
				}
			});
		}
	});
}

/**
 * Builds Facebook share url
 * @return {String}
 */
SocialShare.prototype.facebookShare = function (details) {
	var url = details.url || document.location.href;
	var title = encodeURIComponent( details.title );
	return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url) + '&title=' + title;
}

/**
 * Builds Twitter share url
 * @return {String}
 */
SocialShare.prototype.twitterShare = function (details) {
	var url = details.url || document.location.href;
	var text = encodeURIComponent( details.text.substring(0, 140) ) || "";
	var hashtags = encodeURIComponent( details.hashtags ) || "";
	var via = encodeURIComponent( details.via ) || "";
	return 'http://twitter.com/share?url=' + encodeURI(url) + '&hashtags=' + hashtags + '&via=' + via + '&text=' + text;
}

/**
 * Builds Pinterest share url
 * @return {String}
 */
SocialShare.prototype.pinterestShare = function (details) {
	var url = details.url || document.location.href;
	var media = encodeURI(details.media) || "";
	var description = encodeURIComponent( details.description ) || "";
	return 'http://www.pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&media=' + media + '&description=' + description;;
}

/**
 * Builds LinkedIn share url
 * @return {String}
 */
SocialShare.prototype.linkedinShare = function (details) {
	var url = details.url || document.location.href;
	return 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURI(url);
}

/**
 * Builds Google+ share url
 * @return {String}
 */
SocialShare.prototype.googleplusShare = function (details) {
	var url = details.url || document.location.href;
	return 'https://plus.google.com/share?url=' + encodeURI(url);
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
	init: function (opts) {
		return new SocialShare(opts);
	}
};


// WEBPACK FOOTER //
// ./scripts/components/social.js